import { MKBBox } from '@bluebeam/markupkit-web';
import Point from './Point';

class Rect {
  _left = 0;

  _bottom = 0;

  _right = 0;

  _top = 0;

  static fromPoints(p1: Point, p2: Point): Rect {
    // this._le
    const l = Math.min(p1.x, p2.x);
    const b = Math.min(p1.y, p2.y);
    const r = Math.max(p1.x, p2.x);
    const t = Math.max(p1.y, p2.y);

    return new Rect(l, b, r, t);
  }

  static fromMKBBox(mkBBox: MKBBox): Rect {
    return new Rect(mkBBox.left, mkBBox.bottom, mkBBox.right, mkBBox.top);
  }

  constructor(l: number, b: number, r: number, t: number) {
    this._left = l;
    this._bottom = b;
    this._right = r;
    this._top = t;
  }

  get left(): number {
    return this._left;
  }

  get bottom(): number {
    return this._bottom;
  }

  get right(): number {
    return this._right;
  }

  get top(): number {
    return this._top;
  }

  get width(): number {
    return this._right - this._left;
  }

  get height(): number {
    return this._top - this._bottom;
  }

  get x(): number {
    return this._left;
  }

  get y(): number {
    return this._bottom;
  }

  get center(): Point {
    return {
      x: (this._left + this._right) / 2,
      y: (this._bottom + this._top) / 2,
    };
  }
}

export default Rect;
